<template>
  <with-loader id="conversation-navigation"
               class="flex justify-center items-center border-transparent bg-white border-solid border-0 border-t border-soft"
               :loading="isConversationLoading"
  >
    <conversation-navigation-buttons class="flex"
                                     :disabled-buttons="disabledButtons"
                                     @previous-conversation="selectTargetConversation(-1)"
                                     @previous-request="gotToTargetMessage(-1)"
                                     @next-request="gotToTargetMessage(1)"
                                     @next-conversation="selectTargetConversation(1)"
    >
      <div class="flex gap-1">
        <div v-for="message in getOutcomes($route.query.requestId)"
             :key="message.data.message_id"
             class="flex items-center cursor-pointer hover:opacity-100"
             :class="message.data.message_id === $route.query.requestId ? 'opacity-100' : 'opacity-40'"
             @click="emitSelectedMessage(message)"
        >
          <div class="flex flex-col">
            <chart-legend-icon :type="message.newRequestLegend"
                               :has-tooltip="false"
                               class="h-5"
            />
            <span class="border-0 border-solid border-b-3 rounded w-full"
                  :class="`border-${getUnderLineColor(message.data.message_id, message.newRequestLegend)}`"

            />
          </div>
        </div>
      </div>
    </conversation-navigation-buttons>
  </with-loader>
</template>

<script>
import ChartLegendIcon from '@/components/analytics/charts/ChartLegendIcon.vue'
import WithLoader from '@/components/common/WithLoader.vue'
import ConversationNavigationButtons
  from '@/components/analytics/conversations/detail/ConversationNavigationButtons.vue'
import conversationNavigationUtils, { conversationNavigationVueUtils } from '@/utils/conversation-navigation.utils'
import LABELS from '@/utils/chart-labels'

export default {
  name: 'ConversationNavigation',

  components: {
    ChartLegendIcon,
    WithLoader,
    ConversationNavigationButtons
  },

  props: {
    ...conversationNavigationVueUtils().props
  },

  data() {
    return {
      stepForwardWasClicked: false,
      stepBackWasClicked: false
    }
  },

  computed: {
    ...conversationNavigationVueUtils(conversationNavigationUtils).computed,

    disabledButtons() {
      return {
        previousConversation: !this.previousConversation,
        previousRequest: !this.previousRequest && !this.previousConversation,
        nextRequest: !this.nextRequest && !this.nextConversation,
        nextConversation: !this.nextConversation
      }
    }
  },

  watch: {
    isConversationLoading: {
      immediate: false,
      async handler(value) {
        if (value || (!this.stepForwardWasClicked && !this.stepBackWasClicked)) return

        const requests = conversationNavigationUtils.getRequests()
        await this.gotToTargetMessage(this.stepBackWasClicked ? requests.length : 0)
        this.stepForwardWasClicked = false
        this.stepBackWasClicked = false
      }
    }
  },

  methods: {
    ...conversationNavigationVueUtils(conversationNavigationUtils).methods,

    getOutcomes(requestId) {
      const displayedAmount = 7
      const displayedSideAmount = Math.floor(displayedAmount / 2)
      const messages = conversationNavigationUtils.getRequests()
      const selectedRequestIndex = messages.findIndex(({ data }) => data.message_id === requestId)

      if (messages.length <= displayedAmount) {
        return messages
      } else if (selectedRequestIndex < displayedSideAmount) {
        return messages.slice(0, displayedAmount)
      } else if (messages.length - selectedRequestIndex <= displayedSideAmount) {
        return messages.slice(messages.length - displayedAmount, messages.length)
      } else {
        const messagesBeforeSelected = messages.slice(selectedRequestIndex - displayedSideAmount, selectedRequestIndex)
        const messageSelected = messages[selectedRequestIndex]
        const messagesAfterSelected = messages.slice(selectedRequestIndex + 1, selectedRequestIndex + displayedSideAmount + 1)
        return [...messagesBeforeSelected, messageSelected, ...messagesAfterSelected]
      }
    },

    isRequestsOutcomeSelected(requestId) {
      return this.$route.query.requestId === requestId
    },

    getUnderLineColor(requestId, outcome) {
      if (!this.isRequestsOutcomeSelected(requestId)) return 'background'

      const underlineColorMap = {
        fullyAutomated: LABELS.fullyAutomated.color,
        partiallyAutomated: LABELS.partiallyAutomated.color,
        wrongAnswer: LABELS.wrongAnswer.color,
        notAutomated: LABELS.notAutomated.color,
        requestedOperator: LABELS.requestedOperator.color
      }
      return underlineColorMap[outcome]

    }
  }
}
</script>
